import React from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { IS_ACCEPTANCE, IS_PRODUCTION } from '../../config'
import { Button } from '@material-ui/core'
import { Events } from '../../FSM/shared/constants'
import { FlowService } from '../../FSM'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btnStandards: {
      position: 'absolute',
      top: '20px',
      left: '200px',
      color: theme.palette.secondary.contrastText,
    },
  })
)

// Navigates to UI standards page on LOCAL and DEV environments
const StandardsButton = () => {
  const classes = useStyles()

  return !IS_PRODUCTION && !IS_ACCEPTANCE ? (
    <Button className={classes.btnStandards} onClick={() => FlowService.send(Events.STANDARDS)}>
      UI Standards
    </Button>
  ) : null
}

export default StandardsButton
